export const mutations = {
  setSubscriptions(state, payload) {
    state.subscriptions = payload;
  },
};
